import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveTab,
  setPaginationPageNumber,
  TriggerFilterButtonApi,
} from "../../../slices/common/reducer";
import { setOemFilterForm } from "../../../slices/oem/oemSlice";
import { filterDateOptions } from "../../../Utils/CommonUtils";
import { OEM_FROM_DATE, OEM_TO_DATE } from "../../../Utils/FilterDateKeys";
import { Form, Button, Col, Row, InputGroup } from "react-bootstrap";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import { CiSearch } from "react-icons/ci";
import "./OEM.scss";

function OemFilter() {
  const dispatch = useDispatch();

  const filterForm = useSelector((state) => state.oem.filter.form);
  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  const handleInputChange = (name, value) => {
    dispatch(setOemFilterForm({ name, value }));
    resetTabAndPageNumber();
    dispatch(TriggerFilterButtonApi());
  };

  const handleClear = () => {
    dispatch(setOemFilterForm({ type: "reset" }));

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  const oemOptions = [
    { value: "ACTIVE", label: "Active" },
    { value: "INACTIVE", label: "Inactive" },
  ];

  const isClearButtonDisabled = !Object.values(filterForm).some(
    (value) => value
  );

  return (
    <div className="filter-wrapper">
      <Form className="form-input">
        <Row>
          <Form.Group as={Col} className="col-md-4">
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                {" "}
                <CiSearch />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search for Code, Name..."
                name="code"
                id="code"
                className="oem-searchbar"
                value={filterForm.code || ""}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
              />
            </InputGroup>
          </Form.Group>
          <Form.Group as={Col} className="col-md-4">
            <Select
              isClearable
              placeholder="Status"
              name="status"
              options={oemOptions}
              value={
                oemOptions?.find((itm) => itm.value === filterForm.status) ||
                null
              }
              onChange={(e) => handleInputChange("status", e ? e.value : "")}
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-3">
            <Flatpickr
              className="form-control border-lightgrey"
              placeholder="Select date"
              data-input
              options={filterDateOptions}
              value={[
                filterForm[OEM_FROM_DATE]
                  ? new Date(filterForm[OEM_FROM_DATE])
                  : null,
                filterForm[OEM_TO_DATE]
                  ? new Date(filterForm[OEM_TO_DATE])
                  : null,
              ]}
              onChange={(e) =>
                handleFilterDateChange(
                  e,
                  setOemFilterForm,
                  OEM_FROM_DATE,
                  OEM_TO_DATE
                )
              }
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-1">
            <div>
              <Button
                className="primary-outline"
                onClick={handleClear}
                disabled={isClearButtonDisabled}
              >
                Clear
              </Button>
            </div>
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
}

export default OemFilter;
